<template>
<Layout>
    <PageHeader :breadcrumbs="breadcrumbs" :title="title" />
    <form @submit="uploadUserFile">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="form-group row mb-4">
                <label for="departments" class="col-form-label col-lg-2">
                  {{ $t("talents.create.bulk.department") }}
                </label>
                <div class="col-lg-6">
                  <b-form-group>
                    <b-form-select
                      v-model="$v.selectedDepartment.$model"
                      :options="allDepartments"
                      text-field="title"
                      value-field="id"
                      :state="validateField('selectedDepartment')"
                    >
                    </b-form-select>
                    <b-form-invalid-feedback>
                      {{ $t("validation.min-one") }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </div>
              </div>

              <div class="form-group row mb-4">
                <label for="departments" class="col-form-label col-lg-2">
                  {{ $t("talents.create.bulk.pool") }}
                </label>
                <div class="col-lg-6">
                  <multiselect
                    v-model="selectedPool"
                    :options="allPools"
                    id="pools"
                    name="pools"
                    label="title"
                    track-by="title"
                    multiple
                    :close-on-select="false"
                    selectedLabel=""
                    selectLabel=""
                    deselectLabel=""
                    placeholder=""
                    >
                  </multiselect>
                </div>
              </div>

              <div class="row p-0">
                <span class="col-form-label col-6">
                  <p v-html='$t("talents.create.bulk.template-link-text", {templateLink})'></p>
                </span>
              </div>

              <div class="form-group row mb-4">
                <b-form-file
                class="col-form-label col-6 bulk-import--input"
                accept=".xls, .csv, .xlsx"
                :placeholder='$t("talents.create.bulk.upload-template-placeholder")'
                :browse-text='$t("talents.create.bulk.upload-template-browse-text")'
                v-model="$v.rawTalents.$model"
                :state="validateField('rawTalents')"
                >
                </b-form-file>
                <b-form-invalid-feedback>
                  {{ $t("validation.min-one") }}
                </b-form-invalid-feedback>
              </div>

              <div class="row justify-content-start mb-4">
                <div class="col-lg-6">
                  <button
                  type="submit"
                  class="btn btn-primary">
                  <i
                    class="fa fa-upload"
                    aria-hidden="true"
                    ></i>
                    {{ $t("talents.create.bulk.button-text") }}
                  </button>
                </div>
              </div>
              <b-alert
                :show="isSuccess()"
                variant="success">
                {{ $t('talents.create.bulk.success') }}
              </b-alert>
              <b-alert
                :show="isError()"
                variant="danger">
                  <p>{{ $t('talents.create.bulk.errors-header') }}</p>
                  <ul id="bulk-import--error-list">
                    <li v-for="(error, row) in importMessage" :key="row">
                      {{ $t('talents.validation.affected-row') }} {{ row }}: {{ getErrorMessages(importMessage[row]) }}
                    </li>
                  </ul>
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </form>
</Layout>
</template>

<script>
import i18n from "@/i18n";
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Multiselect from "vue-multiselect";
import { userService } from "@/helpers/services/user/userService";
import { bulkImportService } from "@/helpers/services/talents/bulkImportService";
import { required } from "vuelidate/lib/validators";
import { toastrService } from '@/helpers/services/notification/toastrService';

const page = {
    title: i18n.t("talents.create.bulk.title"),
};

const components = {
  Layout,
  PageHeader,
  Multiselect,
};

export default {
  name: "TalentsBulkImport",
  page,
  components,
  props: ["importMessage", "importType"],
  data() {
    return {
      breadcrumbs: [
        {text: i18n.t('talents.create.bulk.title'), active: true},
      ],
      title: i18n.t('talents.create.bulk.title'),
      allDepartments: [],
      selectedDepartment: null,
      pools: [],
      allPools: [],
      selectedPool: null,
      rawTalents: null,
      templateLink: "https://api.carpe-team.com/files/import_template.xlsx",
    }
  },
  validations: {
    selectedDepartment: {
      required,
    },
    rawTalents: {
      required,
    },
  },
  methods: {
    getErrorMessages(row) {
      const translatedErrors = row.map(error => i18n.t(error));
      return translatedErrors.join(", ");
    },
    isSuccess() {
      return this.importType === toastrService.SUCCESS_TYPE;
    },
    isError() {
      return this.importType === toastrService.ERROR_TYPE;
    },
    validateField(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    uploadUserFile(e) {
      e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      bulkImportService.addMultipleTalentsByFile(
        this.rawTalents,
        this.selectedDepartment,
        this.selectedPool
        );
    },
  },
  created() {
    userService.fetchDepartments()
      .then(departments => this.allDepartments = departments);
    userService.fetchPools()
      .then(pools => this.allPools = pools);
  },
}
</script>

<style>

</style>